import {
  Service
} from '../service.js'
import {
  env
} from '../env.js'

class UsuarioEmpresaService extends Service {
  constructor() {
    super();
    this.url = env.url + "usuarios-por-empresa";
  }

  async listarUsuariosClienteComPermissaoParaAEmpresa(empresasIds) {
    const usuarios_data = await super.get(`${this.url}?empresasIds=${empresasIds}`);
    if (usuarios_data.data?.length > 0) {
      const listaEmpresasUsuarios = usuarios_data.data.map((empresa) => {
          return {
              empresaId: empresa.empresaId,
              usuarios: empresa.usuarios.map((usuario) => {
                  return {
                      value: usuario.id,
                      label: usuario.nome,
                  };
              }),
          };
      });

      return listaEmpresasUsuarios;
  } else {
      return [];
  }
  }
}

export const usuarioEmpresaService = new UsuarioEmpresaService()
